import AddBatch from "../component/Pages/Batch/AddBatch/AddBatch";
import EditBatch from "../component/Pages/Batch/EditBatch/EditBatch";
import Batch from "../component/Pages/Batch/ViewBatch/Batch";
import AddCourses from "../component/Pages/Courses/AddCourses/AddCourses";
import EditCourses from "../component/Pages/Courses/EditCourses/EditCourses";
import Courses from "../component/Pages/Courses/ViewCourses/Courses";
import Center from "../component/Pages/Center/ViewCenter/Center";
import AddCenter from "../component/Pages/Center/AddCenter/AddCenter";
import EditCenter from "../component/Pages/Center/EditCenter/EditCenter";
import Dashboard from "../component/Pages/Dashboard/DashboardView/Dashboard";

import Subject from "../component/Pages/Subject/ViewSubject/Subject";
import AddSubject from "../component/Pages/Subject/AddSubject/AddSubject";
import EditSubject from "../component/Pages/Subject/EditSubject/EditSubject";

import Section from "../component/Pages/Section/ViewSection/Section";
import AddSection from "../component/Pages/Section/AddSection/AddSection";
import EditSection from "../component/Pages/Section/EditSection/EditSection";

import Slot from "../component/Pages/Slot/ViewSlot/Slot";
import AddSlot from "../component/Pages/Slot/AddSlot/AddSlot";
import EditSlot from "../component/Pages/Slot/EditSlot/EditSlot";

import GenerateRegistrationLink from "../component/Pages/GenerateRegistrationLink/ViewGenerateRegistrationLink/GenerateRegistrationLink";
import ViewTotalApplication from "../component/Pages/GenerateRegistrationLink/ViewGenerateRegistrationLink/TotalApplication";
import AddGenerateRegistrationLink from "../component/Pages/GenerateRegistrationLink/AddGenerateRegistrationLink/AddGenerateRegistrationLink";
import EditGenerateRegistrationLink from "../component/Pages/GenerateRegistrationLink/EditGenerateRegistrationLink/EditGenerateRegistrationLink";

import Learner from "../component/Pages/Learner/ViewLearner/Learner";
import AddLearner from "../component/Pages/Learner/AddLearner/AddLearner";
import EditLearner from "../component/Pages/Learner/EditLearner/EditLearner";
import AssignLearner from "../component/Pages/Learner/AssignLearner/AssignLearner";
import Exam from "../component/Pages/Exam/ViewExam/Exam";
import AddExam from "../component/Pages/Exam/AddExam/AddExam";
import EditExam from "../component/Pages/Exam/EditExam/EditExam";
import ExamDashboard from "../component/Pages/Exam/ExamDashboard/ExamDashboard";
import ExamTodayDashboard from "../component/Pages/Exam/ExamTodayDashboard/ExamTodayDashboard";
import ExamResult from "../component/Pages/Exam/ExamResult/ExamResult";
import AddQuestionMain from "../component/Pages/Exam/AddQuestion/AddQuestionMain";
import AddMarksMain from "../component/Pages/Exam/AddMarks/AddMarksMain";
import GeneralizationMain from "../component/Pages/Exam/Generalization/GeneralizationMain";

import AddMarkingSystem from "../component/Pages/MarkingSystem/AddCourses/AddMarking";
import EditMarkingSystem from "../component/Pages/MarkingSystem/EditCourses/EditMarkings";
import MarkingSystem from "../component/Pages/MarkingSystem/ViewCourses/MarkingList";
import AllocatedCenter from "../component/Pages/AllocatedCenter/ViewAllocatedCenter/AllocatedCenter";
import AddAllocatedCenter from "../component/Pages/AllocatedCenter/AddAllocatedCenters/AddAllocateCenter";
import EditAllocatedCenter from "../component/Pages/AllocatedCenter/EditAllocatedCenter/EditAllocatedCenter";
import StudentDetailView from "../component/Pages/GenerateRegistrationLink/ViewGenerateRegistrationLink/viewstudentDetails";
import AdmitCard from "../component/Pages/AdmitCard/AdmitCard/AdmitCard";
import AdmitCardPdf from "../component/Pages/AdmitCard/ViewAdmitCard";
import AllocatedApprovedStudent from "../component/Pages/AllocatedApprovedStudents/ViewAllocatedApprovedStudent/AllocatedApprovedStudent";
import HallTicket from "../component/Pages/GenerateHallTicket/ViewHallTicket/HallTicket";
import ResponseSheet from "../component/Pages/ResponseReport/ResponseReport";
import RankWiseReport from "../component/Pages/RankWiseReport/RankWiseReport";
import SyncDashboard from '../component/Pages/SyncDashboard/SyncDashboard'
import AttendanceReport from "../component/Pages/AttendanceReport/AttendanceReport";
import SectionWiseReport from "../component/Pages/SectionWiseReport/SectionWiseReport";
import Feedback from "../component/Pages/Feedback/ViewFeedback/Feedback";
import AddFeedback from "../component/Pages/Feedback/AddFeedback/AddFeedback";
import EditFeedback from "../component/Pages/Feedback/EditFeedback/EditFeedback";
import ExamFeedbackDashboard from "../component/Pages/Feedback/ExamFeedbackDashboard/ExamFeedbackDashboard";
import ExamFeedbackResult from "../component/Pages/Feedback/ExamFeedbackResult/ExamFeedbackResult";
import AddFeedbackQuestionMain from "../component/Pages/Feedback/AddFeedbackQuestion/AddQuestionMain";
import AddFeedbackMarksMain from "../component/Pages/Feedback/AddFeedbackMarks/AddFeedbackMarksMain";
import ActivityLogs from "../component/Pages/Exam/ActivityLogs/ActivityLogs";
import AllRepors from "../component/Pages/Reports/AllReports.js";
// import MarkingSystem from "../component/Pages/MarkingSystem/Index";

import ConsolidateReport from "../component/Pages/ConsolidateReport/ConsolidateReport"
import MonthlySectionReport from "../component/Pages/MonthlySectionReport/MonthlySectionReport.js"
import DailyDashBoardReport from "../component/Pages/DailyDashboardReport/DailyDashBoardReport";

const BasicSixMonths = [
  {
    id: "dashboard",
    path: "/admin/dashboard",
    element: <Dashboard />,
  },
  {
    id: "center",
    path: "/admin/center",
    element: <Center />,
  },
  {
    id: "addcenter",
    path: "/admin/addcenter",
    element: <AddCenter />,
  },
  {
    id: "editcenter",
    path: "/admin/editcenter/:rowId",
    element: <EditCenter />,
  },
  {
    id: "courses",
    path: "/admin/courses",
    element: <Courses />,
  },
  {
    id: "addcourses",
    path: "/admin/addcourses",
    element: <AddCourses />,
  },
  {
    id: "editcource",
    path: "/admin/editcource/:rowId",
    element: <EditCourses />,
  },
  {
    id: "marking",
    path: "/admin/markingSystem",
    element: <MarkingSystem />,
  },
  {
    id: "addmarking",
    path: "/admin/addMarkingSystem",
    element: <AddMarkingSystem />,
  },
  {
    id: "editmarking",
    path: "/admin/editMarkingSystem/:rowId",
    element: <EditMarkingSystem />,
  },
  {
    id: "batch",
    path: "/admin/batch",
    element: <Batch />,
  },
  {
    id: "addbatch",
    path: "/admin/addbatch",
    element: <AddBatch />,
  },
  {
    id: "editbatch",
    path: "/admin/editbatch/:rowId",
    element: <EditBatch />,
  },
  {
    id: "subject",
    path: "/admin/subject",
    element: <Subject />,
  },
  {
    id: "addsubject",
    path: "/admin/addsubject",
    element: <AddSubject />,
  },
  {
    id: "editsubject",
    path: "/admin/editsubject/:rowId",
    element: <EditSubject />,
  },

  {
    id: "section",
    path: "/admin/section",
    element: <Section />,
  },
  {
    id: "addsection",
    path: "/admin/addsection",
    element: <AddSection />,
  },

  {
    id: "editsection",
    path: "/admin/editsection/:rowId",
    element: <EditSection />,
  },

  {
    id: "slot",
    path: "/admin/slot",
    element: <Slot />,
  },
  {
    id: "addslot",
    path: "/admin/addslot",
    element: <AddSlot />,
  },

  {
    id: "editslot",
    path: "/admin/editslot/:rowId",
    element: <EditSlot />,
  },

  {
    id: "registrationlink",
    path: "/admin/registrationlink",
    element: <GenerateRegistrationLink />,
  },

  {
    id: "viewtotalapplication",
    // path: "/admin/viewtotalapplication",
    path: "/admin/viewtotalapplication",
    element: <ViewTotalApplication />,
  },

  {
    id: "addragistrationlink",
    path: "/admin/generateregistrationlink",
    element: <AddGenerateRegistrationLink />,
  },
  {
    id: "editragistrationlink",
    path: "/admin/editregistrationlink/:rowId",
    element: <EditGenerateRegistrationLink />,
  },

  {
    id: "learner",
    path: "/admin/learner",
    element: <Learner />,
  },
  {
    id: "addlearner",
    path: "/admin/addlearner",
    element: <AddLearner />,
  },
  {
    id: "editlearners",
    path: "/admin/editlearners/:rowId",
    element: <EditLearner />,
  },
  {
    id: "assignlearner",
    path: "/admin/assignlearner",
    element: <AssignLearner />,
  },
  {
    id: "assignlearner_2",
    path: "/admin/assignlearner/:selectedCource1/:selectedBatch1/:selectedCenter1",
    element: <AssignLearner />,
  },

 {
    id: "feedback",
    path: "/admin/feedback",
    element: <Feedback />,
  },
  {
    id: "addfeedback",
    path: "/admin/addfeedback",
    element: <AddFeedback />,
  },
  {
    id: "editfeedback",
    path: "/admin/editfeedback/:rowId",
    element: <EditFeedback />,
  },
   {
    id: "examfeedbackdashboard",
    path: "/admin/examfeedbackdashboard/:rowId",
    element: <ExamFeedbackDashboard />,
  },
  {
    id: "examfeedbackresult",
    path: "/admin/examfeedbackresult/:rowId",
    element: <ExamFeedbackResult />,
  },
  {
    id: "addfeedbackquestion",
    path: "/admin/addfeedbackquestion/:rowId",
    element: <AddFeedbackQuestionMain />,
  },
  {
    id: "addfeedbackmarks",
    path: "/admin/addfeedbackmarks/:rowId",
    element: <AddFeedbackMarksMain />,
  },

  {
    id: "exam",
    path: "/admin/exam",
    element: <Exam />,
  },
  {
    id: "addexam",
    path: "/admin/addexam",
    element: <AddExam />,
  },
  {
    id: "editexam",
    path: "/admin/editexam/:rowId",
    element: <EditExam />,
  },
    {
    id: "examtodaydashboard",
    path: "/admin/examdashboard",
    element: <ExamTodayDashboard />,
  },
  {
    id: "examdashboard",
    path: "/admin/examdashboard/:rowId",
    element: <ExamDashboard />,
  },
   {
    id: "activitylogs",
    path: "/admin/activitylogs/:rowId",
    element: <ActivityLogs />,
  },
  {
    id: "examresult",
    path: "/admin/examresult/:rowId",
    element: <ExamResult />,
  },
  {
    id: "addquestion",
    path: "/admin/addquestion/:rowId",
    element: <AddQuestionMain />,
  },
  {
    id: "addmarks",
    path: "/admin/addmarks/:rowId",
    element: <AddMarksMain />,
  },
  {
    id: "generalization",
    path: "/admin/generalization/:rowId",
    element: <GeneralizationMain />,
  },

  // for allocation center
  {
    id: "allocatedCenter",
    path: "/admin/allocatedcenter",
    element: <AllocatedCenter />,
  },
  {
    id: "addAllocatedCenter",
    path: "/admin/addallocatedcenter",
    element: <AddAllocatedCenter />,
  },
  {
    id: "editAllocatedCenter",
    path: "/admin/editallocatedcenter/:rowId",
    element: <EditAllocatedCenter />,
  },
  {
    id: "viewStudentDetail",
    path: "/admin/studentDetail",
    element: <StudentDetailView />,
  },
  {
    id: "admitCard",
    path: "/admin/admitCard",
    element: <AdmitCard />,
  },
  {
    id: "downloadAdmitCard",
    path: "/admin/admitCardDownload",
    element: <AdmitCardPdf />,
  },
  {
    id: "approvedStudent",
    path: "/admin/approvedStudent",
    element: <AllocatedApprovedStudent />,
  },
  {
    id: "hallTicket",
    path: "/admin/hallTicket",
    element: <HallTicket />,
  },
  {
    id: "attendancereport",
    path: "/admin/attendancereport",
    element: <AttendanceReport />,
  },
  {
    id: "rankwisereport",
    path: "/admin/rankwisereport",
    element: <RankWiseReport />,
  },
  {
    id: "syncdashboard",
    path: "/admin/syncdashboard",
    element: <SyncDashboard />,
  },
  {
    id: "sectionwisereport",
    path: "/admin/sectionwisereport",
    element: <SectionWiseReport />,
  },
  {
    id: "responsesheet",
    path: "/admin/responsereport",
    element: <ResponseSheet />,
  },
  {
    id: "consolidatereport",
    path: "/admin/consolidatereport",
    element: < ConsolidateReport/>,
  },
  {
    id: "monthlysectionreport",
    path: "/admin/monthlysectionreport",
    element: < MonthlySectionReport/>,
  },
  {
    id:"reports",
    path:"/admin/reports",
    element:<AllRepors/>
  },
  {
    id: "dailyreport",
    path: "/admin/dailyreport",
    element: <DailyDashBoardReport />,
  },
  
];

export default BasicSixMonths;
